module.exports = __webpack_public_path__ + "img/EXALT.c765c45d.jpg";